import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getOptionsDemoMode, setOptionsDemoMode } from '../lib/optionsApi';

const OPTIONS_MODE_STORAGE_KEY = 'geni-options-mode';
const OptionsModeContext = createContext(null);

const readStoredMode = () => {
  if (typeof window === 'undefined') return 'real';
  return window.sessionStorage.getItem(OPTIONS_MODE_STORAGE_KEY) === 'demo' ? 'demo' : 'real';
};

export const OptionsModeProvider = ({ children }) => {
  const [mode, setMode] = useState(readStoredMode);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (mode === 'demo') {
        window.sessionStorage.setItem(OPTIONS_MODE_STORAGE_KEY, 'demo');
      } else {
        window.sessionStorage.removeItem(OPTIONS_MODE_STORAGE_KEY);
      }
    }
    setOptionsDemoMode(mode === 'demo');
  }, [mode]);

  useEffect(() => {
    if (!getOptionsDemoMode() && mode === 'demo') {
      setOptionsDemoMode(true);
    }
  }, [mode]);

  const value = useMemo(() => ({
    mode,
    isDemoMode: mode === 'demo',
    enterDemoMode: () => setMode('demo'),
    exitDemoMode: () => setMode('real'),
  }), [mode]);

  return <OptionsModeContext.Provider value={value}>{children}</OptionsModeContext.Provider>;
};

export const useOptionsMode = () => {
  const context = useContext(OptionsModeContext);
  if (!context) {
    throw new Error('useOptionsMode must be used within OptionsModeProvider');
  }
  return context;
};

export default OptionsModeProvider;